// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "../css/" + {"285":"sliderRelated","522":"maps","749":"frames","802":"mapsInfo","842":"editorial","897":"carousel","939":"sliderFull"}[chunkId] + ".css";
};